module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "input-group",
    class: [_vm.setSize]
  }, [(!Array.isArray(_vm.addon) && !_vm.right) ? _c('span', {
    staticClass: "input-group-addon",
    class: [_vm.setBtn]
  }, [_vm._v("\n\t\t" + _vm._s(_vm.addon) + "\n\t\t"), _vm._t("left")], true) : (!_vm.right) ? _c('span', {
    staticClass: "input-group-addon",
    class: [_vm.setBtn]
  }, [_vm._v("\n\t\t" + _vm._s(_vm.addon[0]) + "\n\t")]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._t("input"), _vm._v(" "), (Array.isArray(_vm.addon)) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.addon[1]) + "\n\t")]) : _vm._e(), _vm._v(" "), (!Array.isArray(_vm.addon) && _vm.right) ? _c('span', {
    staticClass: "input-group-addon",
    class: [_vm.setBtn]
  }, [_vm._v("\n\t\t" + _vm._s(_vm.addon) + "\n\t\t"), _vm._t("right")], true) : _vm._e()], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-2fc55872!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/css/form/inputgroup.vue
// module id = 301
// module chunks = 2